var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImgItem = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 296,
  height: 152,
  viewBox: "0 0 296 152",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M55 0C57.2091 0 59 1.79086 59 4V10C59 12.2091 57.2091 14 55 14H4C1.79086 14 0 12.2091 0 10V4C0 1.79086 1.79086 0 4 0H55Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M292 22C294.209 22 296 23.7909 296 26V38C296 40.2091 294.209 42 292 42H4C1.79086 42 0 40.2091 0 38V26C0 23.7909 1.79086 22 4 22H292Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156 50C158.209 50 160 51.7909 160 54V66C160 68.2091 158.209 70 156 70H4C1.79086 70 0 68.2091 0 66V54C0 51.7909 1.79086 50 4 50H156Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M276 82C278.209 82 280 83.7909 280 86V92C280 94.2091 278.209 96 276 96H3.99999C1.79085 96 0 94.2091 0 92V86C0 83.7909 1.79086 82 4 82H276Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M232 100C234.209 100 236 101.791 236 104V110C236 112.209 234.209 114 232 114H4.00001C1.79087 114 0 112.209 0 110V104C0 101.791 1.79086 100 4 100H232Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M137 118C139.209 118 141 119.791 141 122V128C141 130.209 139.209 132 137 132H4C1.79086 132 0 130.209 0 128V122C0 119.791 1.79086 118 4 118H137Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68 140C70.2091 140 72 141.791 72 144V148C72 150.209 70.2091 152 68 152H4C1.79086 152 0 150.209 0 148V144C0 141.791 1.79086 140 4 140H68Z",
  fill: "black"
}))));
export default SvgImgItem;